import { PageHeaderNavigationTab } from "@cdkglobal/radial";
import { useUserContext } from "../../../../contexts/UserContext";
import { StyledSetupsTabWrapper } from "../../../../utils/styled";

const DeepLinkSetupTab = (): JSX.Element => {
  const { selected } = useUserContext();

  if (!selected.setup.value) {
    return <></>;
  }

  return (
    <StyledSetupsTabWrapper>
      <PageHeaderNavigationTab
        id={selected.setup.value}
        data-testid={`${selected.setup.value}-tab`}
        isActive
        label={selected.setup.label}
      />
    </StyledSetupsTabWrapper>
  );
};

export default DeepLinkSetupTab;